import createTableStore from "ds/components/Table/store/useTableStore";

import {
  PERSONAL_API_KEYS_COLUMN_CONFIG,
  PERSONAL_API_KEYS_COLUMNS_STORAGE_KEY,
} from "./constants";

const usePersonalApiKeysTableStore = createTableStore({
  storageKey: PERSONAL_API_KEYS_COLUMNS_STORAGE_KEY,
  config: PERSONAL_API_KEYS_COLUMN_CONFIG,
});

export default usePersonalApiKeysTableStore;
